import PropTypes from 'prop-types';
import React from 'react';
import Button from "../button";

var CancelAddButton = function CancelAddButton(_ref) {
  var onClick = _ref.onClick,
      text = _ref.text;
  return React.createElement(Button, {
    onClick: onClick,
    variant: "link"
  }, text);
};

CancelAddButton.propTypes = {
  text: PropTypes.string,
  onClick: PropTypes.func.isRequired
};
CancelAddButton.defaultProps = {
  text: 'Cancel'
};
export default CancelAddButton;